import FeatureFlag from './feature-flag';

export {
  FeatureFlagProvider,
  FeatureFlagContext,
  useFeatureFlag,
  hasFeatureFlag,
} from './feature-flag';

export default FeatureFlag;
